import * as TemplateTypes from 'types/template.types';
import BaseScene from './base';

/**
 * This is a blank scene which is currently used when restarting the "Game" scene
 * as an intermediary step. This lets the scene change while respecting all the scene transitions
 * ect. so we don't have to stop the music ourselves.
 */
class RestartGame extends BaseScene {
    constructor(){
        super({ 
            key: TemplateTypes.Scene.RESTART_GAME, 
        });
    }

    async create(){
        document.body.style.background = '#000000';
        this.exit('Game');
    }
}

export default RestartGame;